import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { useGetPatientsVisited } from '@vindr/services/actions/patient.action';
import { DefinedColumns } from '@vindr/services/interfaces';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { useTranslation } from 'react-i18next';
import ColumnTemplate from '@vindr/ui/src/components/Templates/columns/columnRenderTemplates';

interface PatientColumnsType
  extends DefinedColumns<ReturnType<typeof useGetPatientsVisited>['data']['data'][number]> {}

const usePatientColumns = (): PatientColumnsType[] => {
  const { t } = useTranslation('Vindoc');

  const { data: institution } = useGetInstitutions({ limit: 100, offset: 0 });

  return [
    {
      title: t('Patient ID'),
      width: 100,
      dataIndex: 'patient_id',
      key: 'patient_id',
      ellipsis: true,
    },
    {
      title: t('Visit ID'),
      width: 100,
      dataIndex: 'visit_id',
      key: 'visit_id',
      ellipsis: true,
    },
    {
      title: t('Patient Name'),
      width: 160,
      dataIndex: 'patient_name',
      key: 'patient_name',
      ellipsis: true,
    },
    {
      title: t('Birthday'),
      width: 90,
      dataIndex: 'birth_date',
      key: 'birth_date',
      ellipsis: true,

      render: (text) => formatDateColumn(text, false),
    },
    ColumnTemplate.Gender({ width: 60 }),
    {
      title: t('Phone'),
      width: 100,
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
    },
    {
      title: t('Address'),
      width: 250,
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
    },
    {
      title: t('Institution'),
      width: 200,
      dataIndex: 'institution_id',
      key: 'institution_id',
      ellipsis: true,

      render: (text) => {
        if (!text) return '';
        const institutionData = institution?.data?.find((item) => item.id === text);

        return institutionData?.name || '';
      },
    },
  ];
};

export default usePatientColumns;
